// extracted by mini-css-extract-plugin
export default {"billing_header":"Billing_billing_header__pLwSm","btn_hand":"Billing_btn_hand__cHd8m","active":"Billing_active__YMexX","absolute_loader":"Billing_absolute_loader__Ynlgv"};